import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk.knowledge-hub.flags.update-categories-for-article-failure.title',
		defaultMessage: "Article's categories not updated",
		description: "Flag title when a knowledge base article's categories fail to be updated",
	},
	description: {
		id: 'servicedesk.knowledge-hub.flags.update-categories-for-article-failure.description',
		defaultMessage: "We weren't able to update the article's categories. Try again in a minute.",
		description: "Flag title when a knowledge base article's categories fail to be updated",
	},
});
